import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import setting from '@/config/setting'
console.log('setting', setting)
const isDev = process.env.NODE_ENV === 'development'
// 生产环境请求的默认域名
axios.defaults.baseURL = isDev ? setting.platform.baseUrlSuffix : setting.baseUrl
// 添加一个请求拦截器
axios.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'
    config.headers['XX-Token'] = ''
    if (store.state.commom.token) {
      config.headers['XX-Token'] = store.state.commom.token
    }
    config.headers['XX-Device-Type'] = 'web'
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
//添加一个响应拦截器
axios.interceptors.response.use(
  res => {
    //在这里对返回的数据进行处理
    let resType = res.headers.get('content-type')
    // 如果返回的是json数据而不是文件流
    if (resType === 'application/json; charset=utf-8') {
      if (res.data.code !== 1) {
        if (res.data.code === 10001) {
          store.commit('commom/setToken', '')
          window.location.href = setting.callbackUrl
          return Promise.reject(res.data.msg)
        } else if (res.data.msg) {
          Vue.prototype.$message.warning(res.data.msg)
        } else {
          Vue.prototype.$message.warning('error')
        }
      }
    }
    return res.data
  },
  err => {
    console.log('网络开了小差！请重试...')
    return Promise.reject(err)
  }
)

export default axios
